export default __webpack_public_path__ + "static/media/search_icon_bold.59af1e7c.svg";